import React from 'react';
import LogoLoader from '../LogoLoader';

/**
 * Legacy spinner API, now drawn as the platform's orb loader (LogoLoader compact) so every caller
 * shows the same loading animation. Sizes and variants keep their meaning: WHITE = a dark surface.
 */

export enum SpinnerSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export enum SpinnerVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WHITE = 'white'
}

interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  className?: string;
}

const sizeMap: Record<SpinnerSize, number> = {
  [SpinnerSize.XS]: 16,
  [SpinnerSize.SM]: 20,
  [SpinnerSize.MD]: 28,
  [SpinnerSize.LG]: 40
};

export const Spinner: React.FC<SpinnerProps> = ({
  size = SpinnerSize.MD,
  variant = SpinnerVariant.PRIMARY,
  className
}) => (
  <LogoLoader
    compact
    size={sizeMap[size] || sizeMap[SpinnerSize.MD]}
    onDark={variant === SpinnerVariant.WHITE}
    className={className}
    label="Loading"
  />
);

export default Spinner;
